const firebaseConfig = {
    apiKey: 'AIzaSyC32KNYFj_GjSEQppSE9nDrgc1QZuVo3X8',
    authDomain: 'tidy-up-32957.firebaseapp.com',
    projectId: 'tidy-up-32957',
    storageBucket: 'tidy-up-32957.appspot.com',
    messagingSenderId: '237484609062',
    appId: '1:237484609062:web:2c8ccca0b1a7c32a0a20e7',
};

export default firebaseConfig;
